import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { queryClient } from '@/lib/react-query/queryClient';
import { authEndpoints } from '@/modules/auth/constants';
import type { ExternalLoginRequest } from '@/modules/auth/types/externalLogin';

export const useExternalLoginMutation = () => {
  return useMutation({
    mutationFn: async (body: ExternalLoginRequest) => {
      const { data } = await fetchClient.POST(authEndpoints.externalLogin, {
        body,
      });
      return data;
    },
    onSuccess: () => {
      // Invalidate all queries after login to ensure we get the latest data for the current user
      queryClient.resetQueries();
    },
  });
};
